export const meetingPlaceEnum = [
    { id: 1, name: 'Zoom' },
    { id: 2, name: 'In Person' },
    { id: 3, name: 'Phone' }
];